import React, { useEffect, useRef } from 'react';
import LottieLoader from 'Components/LottieLoader';
import PropTypes from 'prop-types';


const InfiniteLoader = ({ isLoading, isActive, onShow, hideLoader, height }) => {
  const observerRef = useRef();
  const observerHandler = entries => {
    const [entry] = entries;
    if (isActive && entry.isIntersecting) {
      onShow();
    }
  };
  useEffect(() => {
    if (isActive) {
      const observer = new IntersectionObserver(observerHandler);
      if (observerRef.current) observer.observe(observerRef.current);
      return () => {
        if (observerRef.current) observer.unobserve(observerRef.current);
      };
    }
  }, [isActive]);
  return (
    <div style={ { height: height || '' } } ref={ observerRef } className="infinite-loader">
      { isLoading && !hideLoader && <LottieLoader type="loading" loop={ true } autoplay width="50px" /> }
    </div>
  );
};

InfiniteLoader.propTypes = {
  isLoading: PropTypes.bool,
  isActive: PropTypes.bool,
  onShow: PropTypes.func.isRequired,
  hideLoader: PropTypes.bool,
  height: PropTypes.string,
};


export default InfiniteLoader;
